import React, { useState } from 'react';

const SalaryExpensesForm = ({ data, updateData, nextStep, prevStep }) => {
    const [formData, setFormData] = useState({
        // B. Living Expenses
        groceries: data?.groceries || '',
        vegetables: data?.vegetables || '',
        dairyProducts: data?.dairyProducts || '',
        householdSupplies: data?.householdSupplies || '',

        // Transportation
        fuelDiesel: data?.fuelDiesel || '',
        publicTransport: data?.publicTransport || '',
        taxiCabUber: data?.taxiCabUber || '',
        vehicleMaintenance: data?.vehicleMaintenance || '',
        parkingCharges: data?.parkingCharges || '',
        tollCharges: data?.tollCharges || '',

        // Medical & Healthcare
        doctorConsultationsAmount: data?.doctorConsultationsAmount || '',
        doctorConsultations: data?.doctorConsultations || '',
        doctorConsultationsFrequency: data?.doctorConsultationsFrequency || 'annually',
        
        medicinesAmount: data?.medicinesAmount || '',
        medicines: data?.medicines || '',
        medicinesFrequency: data?.medicinesFrequency || 'monthly',
        
        diagnosticTestsAmount: data?.diagnosticTestsAmount || '',
        diagnosticTests: data?.diagnosticTests || '',
        diagnosticTestsFrequency: data?.diagnosticTestsFrequency || 'annually',
        
        dentalCareAmount: data?.dentalCareAmount || '',
        dentalCare: data?.dentalCare || '',
        dentalCareFrequency: data?.dentalCareFrequency || 'annually',
        
        eyeCareAmount: data?.eyeCareAmount || '',
        eyeCare: data?.eyeCare || '',
        eyeCareFrequency: data?.eyeCareFrequency || 'annually',

        // Education
        schoolFeesAmount: data?.schoolFeesAmount || '',
        schoolFees: data?.schoolFees || '',
        schoolFeesFrequency: data?.schoolFeesFrequency || 'annually',
        
        booksStationeryAmount: data?.booksStationeryAmount || '',
        booksStationery: data?.booksStationery || '',
        booksStationeryFrequency: data?.booksStationeryFrequency || 'annually',
        
        tuitionClassesAmount: data?.tuitionClassesAmount || '',
        tuitionClasses: data?.tuitionClasses || '',
        tuitionClassesFrequency: data?.tuitionClassesFrequency || 'monthly',
        
        extracurricularAmount: data?.extracurricularAmount || '',
        extracurricular: data?.extracurricular || '',
        extracurricularFrequency: data?.extracurricularFrequency || 'monthly',

        // Personal Care
        salonBarber: data?.salonBarber || '',
        
        cosmeticsAmount: data?.cosmeticsAmount || '',
        cosmetics: data?.cosmetics || '',
        cosmeticsFrequency: data?.cosmeticsFrequency || 'monthly',
        
        clothingFootwearAmount: data?.clothingFootwearAmount || '',
        clothingFootwear: data?.clothingFootwear || '',
        clothingFootwearFrequency: data?.clothingFootwearFrequency || 'annually',
    });

    const [expandedSections, setExpandedSections] = useState({
        living: false,
        transportation: false,
        medical: false,
        education: false,
        personal: false,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFrequencyExpenseChange = (field, value) => {
        const newFormData = { ...formData, [field]: value };
        
        // Extract the base field name
        const baseField = field.replace('Amount', '').replace('Frequency', '');
        const amountField = `${baseField}Amount`;
        const freqField = `${baseField}Frequency`;
        
        const amount = parseFloat(newFormData[amountField]) || 0;
        const frequency = newFormData[freqField];
        
        let monthlyValue = 0;
        switch (frequency) {
            case 'monthly':
                monthlyValue = amount;
                break;
            case 'quarterly':
                monthlyValue = amount / 3;
                break;
            case 'halfYearly':
                monthlyValue = amount / 6;
                break;
            case 'annually':
                monthlyValue = amount / 12;
                break;
            default:
                monthlyValue = amount;
        }
        
        newFormData[baseField] = monthlyValue > 0 ? monthlyValue.toFixed(2) : '';
        setFormData(newFormData);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updateData(formData);
        nextStep();
    };

    const toggleSection = (section) => {
        setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    return (
        <div className="form-step">
            <h2 className="step-title">Part 2: Living Expenses</h2>
            <p className="step-description">approximate</p>

            <form onSubmit={handleSubmit} className="diagnosis-form">

                {/* Living Expenses */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('living')}>
                        <span>1. Groceries & Household (Monthly)</span>
                        <span className="toggle-icon">{expandedSections.living ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.living && (
                        <>
                            <InputGroup label="Groceries (Rice, Dal, Oil, Spices, etc.)" name="groceries" value={formData.groceries} onChange={handleChange} />
                            <InputGroup label="Vegetables & Fruits" name="vegetables" value={formData.vegetables} onChange={handleChange} />
                            <InputGroup label="Dairy Products (Milk, Curd, Paneer)" name="dairyProducts" value={formData.dairyProducts} onChange={handleChange} />
                            <InputGroup label="Household Supplies (Detergents, Cleaning)" name="householdSupplies" value={formData.householdSupplies} onChange={handleChange} />
                        </>
                    )}
                </div>

                {/* Transportation */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('transportation')}>
                        <span>2. Transportation (Monthly)</span>
                        <span className="toggle-icon">{expandedSections.transportation ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.transportation && (
                        <>
                            <InputGroup label="Fuel/Petrol/Diesel" name="fuelDiesel" value={formData.fuelDiesel} onChange={handleChange} />
                            <InputGroup label="Public Transport (Metro, Bus, Auto)" name="publicTransport" value={formData.publicTransport} onChange={handleChange} />
                            <InputGroup label="Taxi/Cab (Uber, Ola)" name="taxiCabUber" value={formData.taxiCabUber} onChange={handleChange} />
                            <InputGroup label="Vehicle Maintenance & Servicing" name="vehicleMaintenance" value={formData.vehicleMaintenance} onChange={handleChange} />
                            <InputGroup label="Parking Charges" name="parkingCharges" value={formData.parkingCharges} onChange={handleChange} />
                            <InputGroup label="Toll Charges" name="tollCharges" value={formData.tollCharges} onChange={handleChange} />
                        </>
                    )}
                </div>

                {/* Medical & Healthcare */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('medical')}>
                        <span>3. Medical & Healthcare</span>
                        <span className="toggle-icon">{expandedSections.medical ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.medical && (
                        <>
                            <FrequencyInputGroup 
                                label="Doctor Consultations" 
                                name="doctorConsultationsAmount" 
                                value={formData.doctorConsultationsAmount} 
                                frequency={formData.doctorConsultationsFrequency}
                                freqName="doctorConsultationsFrequency"
                                onChange={(e) => handleFrequencyExpenseChange('doctorConsultationsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('doctorConsultationsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Medicines" 
                                name="medicinesAmount" 
                                value={formData.medicinesAmount} 
                                frequency={formData.medicinesFrequency}
                                freqName="medicinesFrequency"
                                onChange={(e) => handleFrequencyExpenseChange('medicinesAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('medicinesFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Diagnostic Tests" 
                                name="diagnosticTestsAmount" 
                                value={formData.diagnosticTestsAmount} 
                                frequency={formData.diagnosticTestsFrequency}
                                freqName="diagnosticTestsFrequency"
                                onChange={(e) => handleFrequencyExpenseChange('diagnosticTestsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('diagnosticTestsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Dental Care" 
                                name="dentalCareAmount" 
                                value={formData.dentalCareAmount} 
                                frequency={formData.dentalCareFrequency}
                                freqName="dentalCareFrequency"
                                onChange={(e) => handleFrequencyExpenseChange('dentalCareAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('dentalCareFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Eye Care (Spectacles, Contact Lenses)" 
                                name="eyeCareAmount" 
                                value={formData.eyeCareAmount} 
                                frequency={formData.eyeCareFrequency}
                                freqName="eyeCareFrequency"
                                onChange={(e) => handleFrequencyExpenseChange('eyeCareAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('eyeCareFrequency', val)}
                            />
                        </>
                    )}
                </div>

                {/* Education */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('education')}>
                        <span>4. Education</span>
                        <span className="toggle-icon">{expandedSections.education ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.education && (
                        <>
                            <FrequencyInputGroup 
                                label="School/College Fees (Children/Self)" 
                                name="schoolFeesAmount" 
                                value={formData.schoolFeesAmount} 
                                frequency={formData.schoolFeesFrequency}
                                freqName="schoolFeesFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('schoolFeesAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('schoolFeesFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Books & Stationery" 
                                name="booksStationeryAmount" 
                                value={formData.booksStationeryAmount} 
                                frequency={formData.booksStationeryFrequency}
                                freqName="booksStationeryFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('booksStationeryAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('booksStationeryFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Tuition/Coaching Classes" 
                                name="tuitionClassesAmount" 
                                value={formData.tuitionClassesAmount} 
                                frequency={formData.tuitionClassesFrequency}
                                freqName="tuitionClassesFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('tuitionClassesAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('tuitionClassesFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Extracurricular Activities" 
                                name="extracurricularAmount" 
                                value={formData.extracurricularAmount} 
                                frequency={formData.extracurricularFrequency}
                                freqName="extracurricularFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('extracurricularAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('extracurricularFrequency', val)}
                            />
                        </>
                    )}
                </div>

                {/* Personal Care */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('personal')}>
                        <span>5. Personal Care</span>
                        <span className="toggle-icon">{expandedSections.personal ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.personal && (
                        <>
                            <InputGroup label="Salon/Barber Visits (Monthly)" name="salonBarber" value={formData.salonBarber} onChange={handleChange} />
                            <FrequencyInputGroup 
                                label="Cosmetics & Toiletries" 
                                name="cosmeticsAmount" 
                                value={formData.cosmeticsAmount} 
                                frequency={formData.cosmeticsFrequency}
                                freqName="cosmeticsFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('cosmeticsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('cosmeticsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Clothing & Footwear" 
                                name="clothingFootwearAmount" 
                                value={formData.clothingFootwearAmount} 
                                frequency={formData.clothingFootwearFrequency}
                                freqName="clothingFootwearFrequency"
                                options={['quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('clothingFootwearAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('clothingFootwearFrequency', val)}
                            />
                        </>
                    )}
                </div>

                <div className="form-actions">
                    <button type="button" onClick={() => { updateData(formData); prevStep(); }} className="btn-secondary">← Back</button>
                    <button type="submit" className="btn-primary">Next: Discretionary Expenses →</button>
                </div>
            </form>

            <style jsx>{`
                .expense-section { margin-bottom: 25px; padding: 15px; background: #f9fafb; border-radius: 8px; }
                .subsection-title { color: #4b5563; margin-bottom: 12px; font-size: 0.95rem; font-weight: 600; }
                .subsection-title.collapsible { cursor: pointer; user-select: none; display: flex; justify-content: space-between; align-items: center; padding: 10px; background: #fff; border-radius: 6px; transition: background-color 0.2s; }
                .subsection-title.collapsible:hover { background: #f3f4f6; }
                .toggle-icon { font-size: 0.8rem; color: #6b7280; }
            `}</style>
        </div>
    );
};

const FrequencyInputGroup = ({ label, name, value, frequency, freqName, options = ['monthly', 'annually'], onChange, onFreqChange }) => {
    const inputValue = value === null || value === undefined ? '' : String(value);
    
    let divisor = 1;
    if (frequency === 'annually') divisor = 12;
    else if (frequency === 'quarterly') divisor = 3;
    else if (frequency === 'halfYearly') divisor = 6;
    
    const monthlyValue = parseFloat(value) > 0 && frequency !== 'monthly' ? (parseFloat(value) / divisor).toFixed(2) : null;
    
    return (
        <div className="form-group" style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '0.9rem', marginBottom: '6px', display: 'block', fontWeight: '500' }}>{label}</label>
            <div className="input-with-icon" style={{ position: 'relative', marginBottom: '8px' }}>
                <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>₹</span>
                <input
                    type="number"
                    name={name}
                    value={inputValue}
                    onChange={onChange}
                    placeholder="0"
                    style={{ paddingLeft: '25px', width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                    onWheel={(e) => {
                        e.target.blur();
                        e.stopPropagation();
                    }}
                />
            </div>
            <div className="frequency-options" style={{ display: 'flex', gap: '15px', paddingLeft: '2px', flexWrap: 'wrap' }}>
                {options.includes('monthly') && (
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input 
                            type="radio" 
                            name={freqName} 
                            value="monthly" 
                            checked={frequency === 'monthly'} 
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>Monthly</span>
                    </label>
                )}
                {options.includes('quarterly') && (
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input 
                            type="radio" 
                            name={freqName} 
                            value="quarterly" 
                            checked={frequency === 'quarterly'} 
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>Quarterly</span>
                    </label>
                )}
                {options.includes('annually') && (
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input 
                            type="radio" 
                            name={freqName} 
                            value="annually" 
                            checked={frequency === 'annually'} 
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>Annually</span>
                    </label>
                )}
            </div>
            
            {monthlyValue && frequency !== 'monthly' && (
                <div style={{ fontSize: '0.8rem', color: '#059669', background: '#f0fdf4', padding: '6px 10px', borderRadius: '4px', marginTop: '8px' }}>
                    <strong>Monthly Equivalent: ₹{parseFloat(monthlyValue).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</strong>
                </div>
            )}
        </div>
    );
};

const InputGroup = ({ label, name, value, onChange }) => {
    const inputValue = value === null || value === undefined ? '' : String(value);
    return (
        <div className="form-group" style={{ marginBottom: '12px' }}>
            <label style={{ fontSize: '0.9rem', marginBottom: '4px', display: 'block' }}>{label}</label>
            <div className="input-with-icon" style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>₹</span>
                <input
                    type="number"
                    name={name}
                    value={inputValue}
                    onChange={onChange}
                    placeholder="0"
                    style={{ paddingLeft: '25px', width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                    onWheel={(e) => {
                        e.target.blur();
                        e.stopPropagation();
                    }}
                    onKeyDown={(e) => {
                        if (['e', 'E', '+', '-', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default SalaryExpensesForm;
